import React from "react";
import Switch from "@mui/material/Switch";

const SwitchComponent = ({ ...props }) => {
  return <Switch size="small" color="primary" {...props} />;
};

export default SwitchComponent;
